import { injectable } from "inversify";
import "reflect-metadata";
import { IDownloadOnBrowser } from "../types";

@injectable()
export default class DownloadFileOnBrowser implements IDownloadOnBrowser {
  download(file: Blob, fileName: string) {
    const data = window.URL.createObjectURL(file);

    const link = document.createElement("a");

    link.href = data;
    link.download = fileName;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    link.remove();
  }
}
